"use strict";

exports.__esModule = true;
exports.ynabDate = exports.parseDate = exports.placeholders = void 0;

var date_fns_1 = require("date-fns"); // See https://github.com/bank2ynab/bank2ynab/wiki/DateFormatting#dates-in-data-rows


exports.placeholders = {
  '%y': 'yy',
  '%Y': 'yyyy',
  '%m': 'MM',
  '%b': 'MMM',
  '%d': 'dd',
  '%H': 'HH',
  '%M': 'mm',
  '%S': 'ss'
};

var ensureValidity = function ensureValidity(date, input) {
  if (isNaN(date.getTime())) {
    throw new Error(input + " is not a valid date.");
  }

  return date;
};

exports.parseDate = function (input, format) {
  if (!format) {
    return ensureValidity(new Date(Date.parse(input)), input);
  }

  var convertedFormat = Object.keys(exports.placeholders).reduce(function (acc, cur) {
    return acc.replace(cur, exports.placeholders[cur]);
  }, format);
  return ensureValidity(date_fns_1.parse(input, convertedFormat, new Date()), input);
};

exports.ynabDate = function (input) {
  return date_fns_1.format(input, 'MM/dd/yyyy');
};